import { Chip, Tooltip } from "@mui/material";
import { Science } from "@mui/icons-material";
import { useShowTestJobsToggleViewModel } from "./ShowTestJobsToggle.vm";

/**
 * The always-visible cue that "Show Test Jobs" is on. While it is, test jobs sit in the issues
 * queues and the scheduling backlog looking like real work, and the menu item's check mark is
 * hidden inside a closed menu — so the toolbar says so on every page, the way the impersonation
 * chip does. Deleting the chip turns the setting off. Renders nothing while it is off.
 *
 * `compact` shortens the label for the mobile toolbar, where the page title needs the room.
 */
export function ShowTestJobsChip({ compact = false }: { compact?: boolean }) {
	const vm = useShowTestJobsToggleViewModel();
	if (!vm.showTestJobs) return null;
	return (
		<Tooltip title="Test jobs are included in the issue queues and the scheduling backlog">
			<Chip
				icon={<Science />}
				label={compact ? "Test jobs" : "Showing test jobs"}
				color="warning"
				size="small"
				onDelete={vm.toggle}
				sx={{ fontWeight: "bold", mx: 1 }}
			/>
		</Tooltip>
	);
}
